// extracted by mini-css-extract-plugin
export default {"removeButton":"removeButton--q7dl8","removeIcon":"removeIcon--sDodq","error":"error--UfaRf"};